var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #e24c4b;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3455",
    "data-name": "Pfad 3455",
    className: "cls-1",
    d: "M0,0H32V32H0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_9052",
    "data-name": "Gruppe 9052",
    transform: "translate(-34 -34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_9024",
    "data-name": "Gruppe 9024",
    transform: "translate(34 34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_maskieren_1",
    "data-name": "Gruppe maskieren 1",
    className: "cls-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2638",
    "data-name": "Pfad 2638",
    className: "cls-3",
    d: "M16,0A16,16,0,1,1,0,16,16,16,0,0,1,16,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2639",
    "data-name": "Pfad 2639",
    className: "cls-4",
    d: "M16.517,16.517a1.573,1.573,0,0,1-2.2,0l-5.1-5.1-5.1,5.1a1.556,1.556,0,0,1-2.2-2.2l5.1-5.1-5.1-5.1a1.556,1.556,0,0,1,2.2-2.2l5.1,5.1,5.1-5.1a1.556,1.556,0,0,1,2.2,2.2l-5.1,5.1,5.1,5.1a1.563,1.563,0,0,1,0,2.2",
    transform: "translate(6.785 6.785)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.1176ba59c82e4560a1a87b200eb78be9.svg";
export { ForwardRef as ReactComponent };